module.exports = __webpack_public_path__ + "static/media/briefcase-normal.e20dd0a8.svg";